import React, { useEffect, useState, useRef } from 'react';
import { Grid, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { CtaProps } from './RootineCard';
export interface PlayerProps {
  video?: string;
  gif?: string;
  cta?: CtaProps;
}
import { isMobile, sendEvent } from '../utils';

const videoStyle = {
  width: '110px',
  height: '190px',
  maxHeight: '190px',
  borderRadius: '10px',
};

export const VideoPlayer = (props: PlayerProps): JSX.Element => {
  const [playing, setPlaying] = useState<boolean>(false);
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const videoRef = useRef(HTMLVideoElement || null);

  const handleVideoEnd = () => {
    setPlaying(false);
    const eventType = playing ? 'video-play' : 'video-stop';
    sendEvent(eventType, { video: props.video });
  };

  const handleCollapse = () => {
    setCollapsed(!collapsed);
    setPlaying(false);
  };

  const handleCTAClick = () => {
    sendEvent('btn-click', { id: props.cta?.btnId });
    if (props.cta?.link) {
      window.open(props.cta.link, '_blank');
    }
  };
  useEffect(() => {
    if (props.video) {
      const eventType = playing ? 'video-play' : 'video-stop';
      // TODO: see if you can pull the current timestamp the video is at
      if (videoRef?.current && typeof videoRef.current === 'object') {
        // @ts-ignore: Property does not exist
        playing ? videoRef.current?.play() : videoRef.current?.pause();
        if (playing) {
          setCollapsed(false);
        }
      }
      sendEvent(eventType, { video: props.video });
    }
  }, [playing]);
  return (
    <>
      {props.video && (
        <div
          style={{
            background: collapsed ? 'black' : 'transparent',
            textDecoration: 'none',
            position: 'fixed',
            bottom: collapsed ? '100px' : '50px',
            right: isMobile() ? '25px' : '50px',
            zIndex: '1000',
            width: '110px',
            height: collapsed ? '50px' : '260px',
            maxHeight: '260px',
            borderRadius: '10px',
            boxShadow: 'none',
            border: 'none',
            outline: 'none',
            cursor: 'pointer',
          }}
        >
          {!collapsed && (
            <Grid container justifyContent="right">
              <KeyboardArrowDownIcon
                sx={{
                  cursor: 'pointer',
                  position: 'relative',
                  top: 25,
                  zIndex: 1001,
                }}
                onClick={handleCollapse}
              />
            </Grid>
          )}
          {playing && (
            <video
              // @ts-ignore: incorrect type
              ref={videoRef}
              src={props.video}
              style={videoStyle}
              onEnded={() => handleVideoEnd()}
              controls
            ></video>
          )}
          {!playing && !collapsed && <img src={props.gif} style={videoStyle} />}
          {props.cta && (
            <Typography
              variant="light"
              component="p"
              sx={{
                backgroundColor: 'info.main',
                borderRadius: 1,
                py: 0.5,
                width: 110,
                minWidth: 110,
                position: 'relative',
                top: -20,
                color: 'white',
                fontSize: 14,
                textAlign: 'center',
                textDecoration: 'underline',
                zIndex: 1002,
              }}
              onClick={handleCTAClick}
            >
              {props.cta.text}
            </Typography>
          )}
          {!playing && (
            <PlayCircleIcon
              fontSize="large"
              sx={{
                position: 'relative',
                top: collapsed ? -18 : -120,
                left: 35,
                cursor: 'pointer',
                color: 'white',
              }}
              onClick={() => setPlaying(true)}
            />
          )}
        </div>
      )}
    </>
  );
};
